import React from 'react';

/**
 * 결제 실패 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const PaymentFailProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '결제에 실패했습니다'
      },
      {
        name: 'componentProps.errorDefaultMessage',
        label: '기본 에러 메시지',
        control: 'TextField',
        defaultValue: '결제 처리 중 오류가 발생했습니다.'
      },
      {
        name: 'componentProps.showErrorDetails',
        label: '에러 상세 정보 표시',
        control: 'Switch',
        defaultValue: true
      }
    ]
  },
  {
    group: '버튼 설정',
    properties: [
      {
        name: 'componentProps.cartButtonText',
        label: '장바구니 버튼 텍스트',
        control: 'TextField',
        defaultValue: '장바구니로 돌아가기'
      },
      {
        name: 'componentProps.homeButtonText',
        label: '홈 버튼 텍스트',
        control: 'TextField',
        defaultValue: '홈으로 돌아가기'
      },
      {
        name: 'componentProps.redirectToCart',
        label: '장바구니 경로',
        control: 'TextField',
        defaultValue: '/cart'
      },
      {
        name: 'componentProps.redirectToHome',
        label: '홈 경로',
        control: 'TextField',
        defaultValue: '/'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: 'transparent'
      },
      {
        name: 'style.padding',
        label: '패딩',
        control: 'TextField',
        defaultValue: '40px 0'
      },
      {
        name: 'componentProps.className',
        label: 'CSS 클래스',
        control: 'TextField',
        defaultValue: 'payment-fail-wrapper'
      }
    ]
  }
];

export default PaymentFailProperties; 